<acc-page-header>{{ 'overview.name'|translate }}{{ getSubTitle() }}</acc-page-header>

<!-- see https://material.angular.io/cdk/drag-drop/overview#list-wrapping -->

<!-- First Steps START -->
@if (state && !isIronBackupViewer) {
  <acc-first-steps [state]="state"/>
}
<!-- First Steps END -->

<!-- Org START -->
@if (state === AccStateEnum.ORG) {
  <div class="overview">
    <div cdkDropList cdkDropListOrientation="mixed" (cdkDropListDropped)="drop($event)"
         class="d-flex flex-wrap align-items-start overview-flex">
      @for (tpl of templates; track tpl) {
        <ng-template [ngTemplateOutlet]="tpl"/>
      }
      <!-- Contact START -->
      <ng-template #contactTpl>
        @if (org) {
          <div cdkDrag id="contact" class="overview-container">
            <acc-card class="overview-card">
              <acc-card-header size="sm">
                <div class="d-flex gap-2">
                  <div>
                    <a (click)="gotoContactList()" (keydown.enter)="gotoContactList()"
                       tabindex="0">{{ 'contacts'|translate }}</a>
                  </div>
                  @if (perms.contact.write) {
                    <div>
                      <acc-button status="primary" size="xs" class="action"
                                  [ngbTooltip]="'contact.new'|translate "
                                  (accClick)="addNewContact()">
                        <acc-icon name="add"/>
                      </acc-button>
                    </div>
                  }
                  <div cdkDragHandle class="ms-auto acc-drag-handle">
                    <acc-icon name="move-all"/>
                  </div>
                </div>
              </acc-card-header>
              <acc-card-body>
                @if (overview?.contactCount) {
                  <a tabindex="0"
                     (click)="gotoContactList()" (keydown.enter)="gotoContactList()">
                    <div class="overview-line">
                      {{ overview.contactCount | accNumber }} {{ 'contacts'|translate }}
                    </div>
                  </a>
                }
                @if (overview?.contactDebtorCount) {
                  <a tabindex="0"
                     (click)="gotoContactList('DEBTOR')" (keydown.enter)="gotoContactList('DEBTOR')">
                    <div class="overview-line">
                      {{ overview.contactDebtorCount | accNumber }} {{ 'debtors'|translate }}
                    </div>
                  </a>
                }
                @if (overview?.contactCreditorCount) {
                  <a tabindex="0"
                     (click)="gotoContactList('CREDITOR')" (keydown.enter)="gotoContactList('CREDITOR')">
                    <div class="overview-line">
                      {{ overview.contactCreditorCount | accNumber }} {{ 'creditors'|translate }}
                    </div>
                  </a>
                }
                @if (overview?.sheetCount) {
                  <a tabindex="0" (click)="gotoSheetList()" (keydown.enter)="gotoSheetList()">
                    <div class="overview-line">
                      {{ overview.sheetCount | accNumber }} {{ 'sheets'|translate }}
                    </div>
                  </a>
                }
              </acc-card-body>
            </acc-card>
          </div>
        }
      </ng-template>
      <!-- Contact END -->
      <!-- Article -->
      <ng-template #articleTpl>
        @if (org) {
          <div cdkDrag id="article" class="overview-container">
            <acc-card class="overview-card">
              <acc-card-header size="sm">
                <div class="d-flex gap-2">
                  <div>
                    <a (click)="gotoArticleList()" (keydown.enter)="gotoArticleList()"
                       tabindex="0">{{ 'articles'|translate }}</a>
                  </div>
                  @if (perms.article.write) {
                    <div>
                      <acc-button status="primary" size="xs" class="action"
                                  [ngbTooltip]="'article.new'|translate"
                                  (accClick)="addNewArticle()">
                        <acc-icon name="add"/>
                      </acc-button>
                    </div>
                  }
                  <div cdkDragHandle class="ms-auto acc-drag-handle">
                    <acc-icon name="move-all"/>
                  </div>
                </div>
              </acc-card-header>
              <acc-card-body>
                @if (overview?.articleCount) {
                  <a tabindex="0"
                     (click)="gotoArticleList()" (keydown.enter)="gotoArticleList()">
                    <div class="overview-line">
                      {{ overview.articleCount | accNumber }} {{ 'articles'|translate }}
                    </div>
                  </a>
                }
              </acc-card-body>
            </acc-card>
          </div>
        }
      </ng-template>
      <!-- Vehicle -->
      <ng-template #vehicleTpl>
        @if (org) {
          <div cdkDrag id="vehicle" class="overview-container">
            <acc-card class="overview-card">
              <acc-card-header size="sm">
                <div class="d-flex gap-2">
                  <div>
                    <a (click)="gotoContactVehicleList()" (keydown.enter)="gotoContactVehicleList()"
                       tabindex="0">{{ 'vehicles'|translate }}</a>
                  </div>
                  @if (perms.contactVehicle.write) {
                    <div>
                      <acc-button status="primary" size="xs" class="action"
                                  [ngbTooltip]="'contact.vehicle.add'|translate"
                                  (accClick)="addNewContactVehicle()">
                        <acc-icon name="add"/>
                      </acc-button>
                    </div>
                  }
                  <div cdkDragHandle class="ms-auto acc-drag-handle">
                    <acc-icon name="move-all"/>
                  </div>
                </div>
              </acc-card-header>
              <acc-card-body>
                @if (overview?.contactVehicleCount) {
                  <a (click)="gotoContactVehicleList()"
                     (keydown.enter)="gotoContactVehicleList()" tabindex="0">
                    <div class="overview-line">
                      {{ overview.contactVehicleCount | accNumber }} {{ 'contact.vehicles'|translate }}
                    </div>
                  </a>
                }
                @if (overview?.contactVehicleInspectionCount) {
                  <a (click)="gotoContactVehicleInspectionList()"
                     (keydown.enter)="gotoContactVehicleInspectionList()" tabindex="0">
                    <div class="overview-line">
                      {{ overview.contactVehicleInspectionCount | accNumber }} {{ 'vehicle.nextTechnicalInspections'|translate }}
                    </div>
                  </a>
                }
                @if (overview?.contactVehicleTireChangeCount) {
                  <a (click)="gotoContactVehicleTireChangeList()"
                     (keydown.enter)="gotoContactVehicleTireChangeList()" tabindex="0">
                    <div class="overview-line">
                      {{ overview.contactVehicleTireChangeCount | accNumber }} {{ 'vehicle.nextTireChanges'|translate }}
                    </div>
                  </a>
                }
              </acc-card-body>
            </acc-card>
          </div>
        }
      </ng-template>
      <!-- Invoice -->
      <ng-template #invoiceTpl>
        @if (org) {
          <div cdkDrag id="invoice" class="overview-container">
            <acc-card class="overview-card">
              <acc-card-header size="sm">
                <div class="d-flex gap-2">
                  <div>
                    <a (click)="gotoInvoiceList()" (keydown.enter)="gotoInvoiceList()"
                       tabindex="0">{{ 'invoices'|translate }}</a>
                  </div>
                  @if (perms.invoice.write) {
                    <div>
                      <acc-button status="primary" size="xs" class="action"
                                  [ngbTooltip]="'invoice.new'|translate"
                                  (accClick)="createNewInvoice()">
                        <acc-icon name="add"/>
                      </acc-button>
                    </div>
                  }
                  <div cdkDragHandle class="ms-auto acc-drag-handle">
                    <acc-icon name="move-all"/>
                  </div>
                </div>
              </acc-card-header>
              <acc-card-body>
                <!-- Draft -->
                @if (overview?.invoiceDraftCount) {
                  <a (click)="gotoInvoiceList('DRAFT')"
                     (keydown.enter)="gotoInvoiceList('DRAFT')" tabindex="0">
                    <div class="d-flex overview-line">
                      <div>
                        {{ overview.invoiceDraftCount | accNumber }} {{ 'overview.invoice.drafts'|translate }}
                      </div>
                      @if (overview.invoiceDraftSumNetAmount) {
                        <div class="ms-auto">
                          <acc-icon name="amount" class="pointer"
                                    [ngbTooltip]="('invoice.totalNetAmount.short' | translate) + ' ' + (overview.invoiceDraftSumNetAmount|accAmount:org.defaultCurrency)"/>
                        </div>
                      }
                    </div>
                  </a>
                }
                <!-- Order -->
                @if (overview?.invoiceOrderCount) {
                  <a (click)="gotoInvoiceList('ORDER')"
                     (keydown.enter)="gotoInvoiceList('ORDER')" tabindex="0">
                    <div class="d-flex overview-line">
                      <div>
                        {{ overview.invoiceOrderCount | accNumber }} {{ 'overview.invoice.orders'|translate }}
                      </div>
                      @if (overview.invoiceOrderSumNetAmount) {
                        <div class="ms-auto">
                          <acc-icon name="amount" class="pointer"
                                    [ngbTooltip]="('invoice.totalNetAmount.short' | translate) + ' ' + (overview.invoiceOrderSumNetAmount|accAmount:org.defaultCurrency)"/>
                        </div>
                      }
                    </div>
                  </a>
                }
                <!-- Invoice: unpaid START -->
                @if (overview?.invoiceUnpaidCount) {
                  <a (click)="gotoInvoiceList('INVOICE', false)"
                     (keydown.enter)="gotoInvoiceList('INVOICE')" tabindex="0">
                    <div class="d-flex overview-line">
                      <div>
                        {{ overview.invoiceUnpaidCount | accNumber }}
                        {{ 'overview.invoices.orders'|translate }}
                      </div>
                      @if (overview.invoiceUnpaidAmount) {
                        <div class="ms-auto">
                          <acc-icon name="amount" class="pointer"
                                    [ngbTooltip]="('invoice.totalNetAmount.short' | translate) + ' ' + (overview.invoiceUnpaidAmount|accAmount:org.defaultCurrency)"/>
                        </div>
                      }
                    </div>
                  </a>
                }
                <!-- Invoice: unpaid END -->
                <!-- Invoice: current year -->
                @if (overview?.invoiceCurrentYearCount) {
                  <a (click)="gotoInvoiceList('INVOICE', undefined, overview.invoiceCurrentYear)"
                     (keydown.enter)="gotoInvoiceList('INVOICE', undefined, overview.invoiceCurrentYear)" tabindex="0">
                    <div class="d-flex overview-line">
                      <div>
                        {{ overview.invoiceCurrentYearCount | accNumber }}
                        {{ 'invoices'|translate }}
                        ({{ overview.invoiceCurrentYear }})
                      </div>
                      @if (overview.invoiceCurrentYearSumNetAmount) {
                        <div class="ms-auto">
                          <acc-icon name="amount" class="pointer"
                                    [ngbTooltip]="('invoice.totalNetAmount.short' | translate) + ' ' + (overview.invoiceCurrentYearSumNetAmount|accAmount:org.defaultCurrency)"/>
                        </div>
                      }
                    </div>
                  </a>
                }
                <!-- Invoice: last year
                <a *ngIf="overview?.invoiceLastYearCount" (click)="gotoInvoiceList('INVOICE')"
                  (keydown.enter)="gotoInvoiceList('INVOICE')" tabindex="0">
                  <div class="d-flex overview-line">
                    <div>
                      {{ overview?.invoiceLastYearCount | number }} {{ 'invoices'|translate }}
                      ({{ overview?.invoiceLastYear }})
                    </div>
                    <div class="ms-auto">
                      <acc-icon name="amount" class="pointer"
                        [ngbTooltip]="('invoice.totalNetAmount.short' | translate) + ' ' + (overview?.invoiceLastYearSumNetAmount|accAmount:org.defaultCurrency)"/>
                      </div>
                    </div>
                  </a> -->
              </acc-card-body>
            </acc-card>
          </div>
        }
      </ng-template>
      <!-- Receipt -->
      <ng-template #receiptTpl>
        @if (org) {
          <div cdkDrag id="receipt" class="overview-container">
            <acc-card class="overview-card">
              <acc-card-header size="sm">
                <div class="d-flex gap-2">
                  <div>
                    <a (click)="gotoReceiptList()" (keydown.enter)="gotoReceiptList()"
                       tabindex="0">{{ 'receipts'|translate }}</a>
                  </div>
                  @if (perms.invoice.write) {
                    <div>
                      <acc-button status="primary" size="xs" class="action"
                                  [ngbTooltip]="'receipt.new'|translate"
                                  (accClick)="createNewReceipt()">
                        <acc-icon name="add"/>
                      </acc-button>
                    </div>
                  }
                  <div cdkDragHandle class="ms-auto acc-drag-handle">
                    <acc-icon name="move-all"/>
                  </div>
                </div>
              </acc-card-header>
              <acc-card-body>
                <!-- Receipt Total -->
                @if (overview?.receiptCount) {
                  <a tabindex="0"
                     (click)="gotoReceiptList()" (keydown.enter)="gotoReceiptList()">
                    <div class="d-flex overview-line">
                      <div>
                        {{ overview.receiptCount | accNumber }} {{ 'overview.receipt.count'|translate }}
                      </div>
                      @if (overview.receiptSumNetAmount) {
                        <div class="ms-auto">
                          <acc-icon name="amount" class="pointer"
                                    [ngbTooltip]="('overview.net' | translate) + ' ' + (overview.receiptSumNetAmount|accAmount:org.defaultCurrency)"/>
                        </div>
                      }
                    </div>
                  </a>
                }
                <!-- Receipt Unreviewed -->
                @if (overview?.receiptUnreviewedCount) {
                  <a tabindex="0"
                     (click)="gotoReceiptList('filterReviewed','false')"
                     (keydown.enter)="gotoReceiptList('filterReviewed','false')">
                    <div class="d-flex overview-line">
                      <div>
                        {{ overview.receiptUnreviewedCount | accNumber }} {{ 'receipt.notReviewed'|translate }}
                      </div>
                      @if (overview.receiptUnreviewedSumNetAmount) {
                        <div class="ms-auto">
                          <acc-icon name="amount" class="pointer"
                                    [ngbTooltip]="('overview.net' | translate) + ' ' + (overview.receiptUnreviewedSumNetAmount|accAmount:org.defaultCurrency)"/>
                        </div>
                      }
                    </div>
                  </a>
                }
                <!-- Receipt Unpaid -->
                @if (overview?.receiptUnpaidCount) {
                  <a tabindex="0"
                     (click)="gotoReceiptList('filterPayment','false')"
                     (keydown.enter)="gotoReceiptList('filterPayment','false')">
                    <div class="d-flex overview-line">
                      <div>
                        {{ overview.receiptUnpaidCount | accNumber }} {{ 'payment.unpaid'|translate }}
                      </div>
                      @if (overview.receiptUnpaidAmount) {
                        <div class="ms-auto">
                          <acc-icon name="amount" class="pointer"
                                    [ngbTooltip]="('overview.sum' | translate) + ' ' + (overview.receiptUnpaidAmount|accAmount:org.defaultCurrency)"/>
                        </div>
                      }
                    </div>
                  </a>
                }
              </acc-card-body>
            </acc-card>
          </div>
        }
      </ng-template>
      <!-- Media START -->
      <ng-template #mediaTpl>
        @if (org) {
          <div cdkDrag id="media" class="overview-container">
            <acc-card class="overview-card">
              <acc-card-header size="sm">
                <div class="d-flex gap-2">
                  <div>
                    <a (click)="gotoMediaList()" (keydown.enter)="gotoMediaList()" tabindex="0">
                      {{ 'medias'|translate }}
                    </a>
                  </div>
                  <div cdkDragHandle class="ms-auto acc-drag-handle">
                    <acc-icon name="move-all"/>
                  </div>
                </div>
              </acc-card-header>
              <acc-card-body>
                @if (overview?.mediaCount) {
                  <a (click)="gotoMediaList()" (keydown.enter)="gotoMediaList()" tabindex="0">
                    <div class="overview-line">
                      {{ overview.mediaCount | accNumber }} {{ 'medias'|translate }}
                    </div>
                  </a>
                }
                @if (overview?.mediaSize) {
                  <a (click)="gotoMediaList()" (keydown.enter)="gotoMediaList()" tabindex="0">
                    <div class="overview-line">
                      {{ overview.mediaSize | fileSize }} {{ 'media.used'|translate }}
                    </div>
                  </a>
                }
              </acc-card-body>
            </acc-card>
          </div>
        }
      </ng-template>
      <!-- Media END -->
      <!-- Funeral/Death START -->
      <ng-template #deathTpl>
        @if (org) {
          <div cdkDrag id="death" class="overview-container">
            <acc-card class="overview-card">
              <acc-card-header size="sm">
                <div class="d-flex gap-2">
                  <div>
                    <a (click)="gotoDeathList()" (keydown.enter)="gotoDeathList()" tabindex="0">
                      {{ 'funerals'|translate }}
                    </a>
                  </div>
                  <div cdkDragHandle class="ms-auto acc-drag-handle">
                    <acc-icon name="move-all"/>
                  </div>
                </div>
              </acc-card-header>
              <acc-card-body>
                <!-- Death: total count -->
                @if (overview && overview.deathCount) {
                  <a (click)="gotoDeathList()" (keydown.enter)="gotoDeathList()" tabindex="0">
                    <div class="overview-line">
                      {{ overview.deathCount | accNumber }} {{ (overview.deathCount > 1 ? 'funerals' : 'funeral')|translate }}
                    </div>
                  </a>
                }
                <!-- Death: current year count -->
                @if (overview && overview.deathCurrentYearCount && overview.deathCurrentYear) {
                  <a (click)="gotoDeathList(overview.deathCurrentYear)"
                     (keydown.enter)="gotoDeathList(overview.deathCurrentYear)" tabindex="0">
                    <div class="d-flex overview-line">
                      <div>
                        {{ overview.deathCurrentYearCount | accNumber }}
                        {{ (overview.deathCurrentYearCount > 1 ? 'funerals' : 'funeral')|translate }}
                        ({{ overview.deathCurrentYear }})
                      </div>
                    </div>
                  </a>
                }
                <!-- Death: last year count -->
                @if (overview && overview.deathLastYearCount && overview.deathLastYear) {
                  <a (click)="gotoDeathList(overview.deathLastYear)"
                     (keydown.enter)="gotoDeathList(overview.deathLastYear)" tabindex="0">
                    <div class="d-flex overview-line">
                      <div>
                        {{ overview.deathLastYearCount | accNumber }}
                        {{ (overview.deathLastYearCount > 1 ? 'funerals' : 'funeral')|translate }}
                        ({{ overview.deathLastYear }})
                      </div>
                    </div>
                  </a>
                }
              </acc-card-body>
            </acc-card>
          </div>
        }
      </ng-template>
      <!-- Funeral/Death END -->
    </div>
  </div>
}
<!-- Org END -->

<!-- User START -->
@if (state === AccStateEnum.USER) {
  <div class="overview">
    @if (user) {
      <div cdkDropList cdkDropListOrientation="mixed" (cdkDropListDropped)="drop($event)"
           class="d-flex flex-wrap align-items-start overview-flex">
        @for (tpl of templates; track tpl) {
          <ng-template [ngTemplateOutlet]="tpl"/>
        }
        <!-- Assigned Orgs -->
        <ng-template #assignedOrgTpl>
          <div cdkDrag id="assignedOrg" class="overview-container">
            <acc-card class="overview-card">
              <acc-card-header size="sm">
                <div class="d-flex gap-2">
                  <div>
                    <a (click)="gotoAssignedOrgList()" (keydown.enter)="gotoAssignedOrgList()" tabindex="0">
                      {{ 'orgs'|translate }}
                    </a>
                  </div>
                  <div cdkDragHandle class="ms-auto acc-drag-handle">
                    <acc-icon name="move-all"/>
                  </div>
                </div>
              </acc-card-header>
              @if (overview && overview.assignedOrgCount !== undefined) {
                <acc-card-body>
                  @if (overview.assignedOrgCount >= 1) {
                    <a
                      (click)="gotoAssignedOrgList()" (keydown.enter)="gotoAssignedOrgList()" tabindex="0">
                      <div class="overview-line">
                        {{ overview.assignedOrgCount | accNumber }} {{ 'orgs'|translate }}
                      </div>
                    </a>
                  }
                  @if (overview.assignedOrgCount === 0) {
                    <acc-button (accClick)="gotoOrgAdd()" size="sm">
                      <acc-icon name="add"/>
                      {{ 'org.add'|translate }}
                    </acc-button>
                  }
                </acc-card-body>
              }
            </acc-card>
          </div>
        </ng-template>
      </div>
    }
  </div>
}
<!-- User END -->

@if (!isIronBackupViewer) {
  <div class="small fst-italic">
    {{ 'overview.update.info'|translate }}
  </div>
}
